import connect from './connect'
import OrderPage from './OrderPage'

export default connect(OrderPage)
